module.exports = __webpack_public_path__ + "r-v3/img/zoom_fit_white.87072aca.svg";